var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.0625 20.9219V6.90625C4.0625 4.66258 5.88133 2.84375 8.125 2.84375H5.07812C2.83446 2.84375 1.01562 4.66258 1.01562 6.90625V20.9219C1.01562 23.1655 2.83446 24.9844 5.07812 24.9844H8.125C5.88133 24.9844 4.0625 23.1655 4.0625 20.9219Z",
    fill: "url(#paint0_linear_969_505)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89062 13H7.92188",
    stroke: "black",
    strokeWidth: 2.03125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90625 1.01562V4.875M13 1.01562V4.875M19.0938 1.01562V4.875M1.01562 8.9375H24.9844V6.90625C24.9844 4.66258 23.1655 2.84375 20.9219 2.84375H5.07812C2.83446 2.84375 1.01562 4.66258 1.01562 6.90625V20.9219C1.01562 23.1655 2.83446 24.9844 5.07812 24.9844H20.9219C23.1655 24.9844 24.9844 23.1655 24.9844 20.9219V13M5.89062 17.0625H7.92188M5.89062 21.125H7.92188M11.9844 17.0625H14.0156M11.9844 21.125H14.0156M18.0781 17.0625H20.1094M11.9844 13H14.0156M18.0781 13H20.1094M18.0781 21.125H20.1094",
    stroke: "url(#paint1_linear_969_505)",
    strokeWidth: 2.04286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 13H14.0156",
    stroke: "url(#paint2_linear_969_505)",
    strokeWidth: 2.04286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 13H14.0156",
    stroke: "black",
    strokeWidth: 2.04286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_969_505",
    x1: 1.01562,
    y1: 2.84375,
    x2: 14.2849,
    y2: 9.78176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_969_505",
    x1: 1.57292,
    y1: 1.03125,
    x2: 19.4077,
    y2: 28.5676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE56B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_969_505",
    x1: 1,
    y1: 24.4514,
    x2: 28.6083,
    y2: 6.57002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE56B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateCalendar);
export default __webpack_public_path__ + "static/media/dateCalendar.f52b802ad634f73eb5d4fffe64c853e0.svg";
export { ForwardRef as ReactComponent };